<template>
    <OperationCard
        :operation="operation"
        @toOperation="toOperation"
        :mainAmount="operation.amount"
        :mainAmountAbbr="operation.currency.abbr"
        :convertAmount="operation.amountUsd"
        :convertAmountText="getOperationTypeText()"
    >
        <template v-if="!isIncludedSlugs" #icon>
            <i class="icon logo-round-plus-svg"></i>
        </template>
    </OperationCard>
</template>

<script setup lang="ts">
import { computed } from "vue";
import ModelAccount from "@models/v2/account/ModelAccount";
import PurchaseOperation from "@models/operations/PurchaseOperation";
import OperationCard from "@components/atomic/operations/cards/atomic/OperationCard.vue";
import {useTranslate} from "@tolgee/vue";

const { t } = useTranslate();

interface Emits {
    (e: 'toOperation'): void,
}

interface Props {
    operation: PurchaseOperation;
    account: ModelAccount;
}

const emits = defineEmits<Emits>();

const props = defineProps<Props>();

const slugs = ["olimp", "olimp-casino"];

const isIncludedSlugs = computed(() => {
    return slugs.includes(String(props.account.project.slug));
});

const toOperation = async () => {
    emits('toOperation');
}

function getOperationTypeText() {
    switch (props.operation.operationType) {
        case "purchase":
            if (isIncludedSlugs.value) {
                return t.value('payment.pay');
            }
            return t.value('payment.purchase');
        case "sale":
            return t.value('payment.sale');
    }
    return "";
}
</script>

<style lang="scss">
</style>
